<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('businessTableHisManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="businessTableHisManageInfo.conditions" class="flex justify-start">
        <el-form-item>
          <el-form-item>
            <el-select v-model="businessTableHisManageInfo.conditions.action"
              :placeholder="$t('businessTableHisManage.selectAction')" style="width:100%">
              <el-option :label="$t('businessTableHisManage.pleaseSelect')" value=""></el-option>
              <el-option label="ADD" value="ADD"></el-option>
              <el-option label="MOD" value="MOD"></el-option>
              <el-option label="DEL" value="DEL"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="businessTableHisManageInfo.conditions.actionObj"
              :placeholder="$t('businessTableHisManage.inputTableName')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="businessTableHisManageInfo.conditions.businessTypeCd"
              :placeholder="$t('businessTableHisManage.inputBusinessType')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryBusinessTableHisMethod">
              <i class="el-icon-search"></i>
              {{ $t('businessTableHisManage.query') }}
            </el-button>
            <el-button @click="_resetBusinessTableHisMethod">
              <i class="el-icon-refresh"></i>
              {{ $t('businessTableHisManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('businessTableHisManage.businessTrack') }}</span>
        <div>
          <el-button type="primary" size="small" @click="_openAddBusinessTableHisModal">
            <i class="el-icon-plus"></i>
            {{ $t('businessTableHisManage.add') }}
          </el-button>
        </div>
      </div>
      <el-table :data="businessTableHisManageInfo.businessTableHiss" border style="width:100%">
        <el-table-column prop="hisId" :label="$t('businessTableHisManage.trackId')" align="center"></el-table-column>
        <el-table-column prop="businessTypeCd" :label="$t('businessTableHisManage.businessType')"
          align="center"></el-table-column>
        <el-table-column prop="action" :label="$t('businessTableHisManage.action')" align="center">
          <template slot-scope="scope">
            {{ scope.row.action === 'ADD' ? $t('businessTableHisManage.add') :
              scope.row.action === 'MOD' ? $t('businessTableHisManage.modify') :
                $t('businessTableHisManage.delete') }}
          </template>
        </el-table-column>
        <el-table-column prop="actionObj" :label="$t('businessTableHisManage.tableName')"
          align="center"></el-table-column>
        <el-table-column prop="actionObjHis" :label="$t('businessTableHisManage.trackTableName')"
          align="center"></el-table-column>
        <el-table-column :label="$t('businessTableHisManage.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_openEditBusinessTableHisModel(scope.row)">
                {{ $t('businessTableHisManage.modify') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteBusinessTableHisModel(scope.row)">
                {{ $t('businessTableHisManage.delete') }}
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="businessTableHisManageInfo.conditions.page"
        :page-size="businessTableHisManageInfo.conditions.row" layout="total, prev, pager, next"
        :total="businessTableHisManageInfo.total" style="margin-top:20px;text-align:right"></el-pagination>
    </el-card>

    <add-business-table-his ref="addBusinessTableHis" @success="_listBusinessTableHiss"></add-business-table-his>
    <edit-business-table-his ref="editBusinessTableHis" @success="_listBusinessTableHiss"></edit-business-table-his>
    <delete-business-table-his ref="deleteBusinessTableHis" @success="_listBusinessTableHiss"></delete-business-table-his>
  </div>
</template>

<script>
import { listBusinessTableHis } from '@/api/dev/businessTableHisApi'
import AddBusinessTableHis from '@/components/dev/addBusinessTableHis/addBusinessTableHis'
import EditBusinessTableHis from '@/components/dev/editBusinessTableHis/editBusinessTableHis'
import DeleteBusinessTableHis from '@/components/dev/deleteBusinessTableHis/deleteBusinessTableHis'

export default {
  name: 'BusinessTableHisManage',
  components: {
    AddBusinessTableHis,
    EditBusinessTableHis,
    DeleteBusinessTableHis
  },
  data() {
    return {
      businessTableHisManageInfo: {
        businessTableHiss: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          action: '',
          actionObj: '',
          businessTypeCd: ''
        }
      }
    }
  },
  created() {
    this._listBusinessTableHiss()
  },
  methods: {
    async _listBusinessTableHiss() {
      try {
        const params = {
          ...this.businessTableHisManageInfo.conditions
        }
        const res = await listBusinessTableHis(params)
        this.businessTableHisManageInfo.businessTableHiss = res.data
        this.businessTableHisManageInfo.total = res.total
      } catch (error) {
        console.error('获取业务轨迹列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.businessTableHisManageInfo.conditions.page = val
      this._listBusinessTableHiss()
    },
    _openAddBusinessTableHisModal() {
      this.$refs.addBusinessTableHis.open()
    },
    _openEditBusinessTableHisModel(row) {
      this.$refs.editBusinessTableHis.open(row)
    },
    _openDeleteBusinessTableHisModel(row) {
      this.$refs.deleteBusinessTableHis.open(row)
    },
    _queryBusinessTableHisMethod() {
      this.businessTableHisManageInfo.conditions.page = 1
      this._listBusinessTableHiss()
    },
    _resetBusinessTableHisMethod() {
      this.businessTableHisManageInfo.conditions = {
        page: 1,
        row: 10,
        action: '',
        actionObj: '',
        businessTypeCd: ''
      }
      this._listBusinessTableHiss()
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>